import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { SectorComercialFields, UnidadNegocioFields } from 'src/types'
import { SectorComercialTipo, UnidadNegocioTipo } from 'src/types/enum/enum'
import { AsyncSelect, ControlledDatePicker } from "../../../../../components/forms"
import { useLoadOptions } from "../../../../../hooks/useLoadOptions"
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { useLEPSectorComercial, useLEPUnidadNegocio } from '../hooks/useLEPCache'
import { OperacionLEPFields } from "../types/fields"

interface SeccionLEPDatosOperacionProps {
  formMethods: UseFormReturn<any>
  codSistema: number,
  codPais: number
}

export const SeccionNuevoLEPDatosOperacion = ({ formMethods, codSistema, codPais }: SeccionLEPDatosOperacionProps) => {
  const { control, setValue } = formMethods

  const unidadNegocioHook = useLEPUnidadNegocio(codPais, codSistema)
  const watchedUnidadNegocio = useWatch({ control, name: OperacionLEPFields.CodUnidadNegocio });
  const sectorComercialHook = useLEPSectorComercial(watchedUnidadNegocio, codSistema);


  useEffect(() => {
    if (unidadNegocioHook.unidadNegocio?.length) {
      const match = unidadNegocioHook.unidadNegocio.find(
        (un) => un[UnidadNegocioFields.UnidadNegocioTipo] === UnidadNegocioTipo.CorporateAndInvestmentBanking
      );
      if (match) {
        setValue(OperacionLEPFields.CodUnidadNegocio, match[SectorComercialFields.UnidadNegocioCodigo]);
      }
    }
  }, [unidadNegocioHook.unidadNegocio, setValue]);


  useEffect(() => {
    if (sectorComercialHook.sectorComercialTipos?.length) {
      const match = sectorComercialHook.sectorComercialTipos.find(
        (sc) => sc[SectorComercialFields.SectorComercialTipo] === SectorComercialTipo.CapitalMarkets
      );
      if (match) {
        setValue(OperacionLEPFields.CodSectorComercial, match[SectorComercialFields.SectorComercialCodigo]);
      }
    }
  }, [sectorComercialHook.sectorComercialTipos, setValue]);


  const loadUnidadNegocio = useLoadOptions({
    data: unidadNegocioHook.unidadNegocio,
    loading: unidadNegocioHook.isLoading,
    isError: unidadNegocioHook.isError,
    error: unidadNegocioHook.error
  });


  const loadSectorComercial = useLoadOptions({
    data: sectorComercialHook.sectorComercialTipos,
    loading: sectorComercialHook.isLoading,
    isError: sectorComercialHook.isError,
    error: sectorComercialHook.error
  });

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'Unidad de Negocio'}
            name={OperacionLEPFields.CodUnidadNegocio}
            valueField={SectorComercialFields.UnidadNegocioCodigo}
            loadOptions={loadUnidadNegocio} control={control}
            selectNotNulleable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'Equipo Comercial'}
            name={OperacionLEPFields.CodSectorComercial}
            valueField={SectorComercialFields.SectorComercialCodigo}
            loadOptions={loadSectorComercial} control={control}
            selectNotNulleable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledDatePicker name={OperacionLEPFields.FechaAprobacion} control={control}
            label='Fecha Solicitud' disabled/>
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledDatePicker name={OperacionLEPFields.FechaVencimiento} control={control}
            label='Fecha Vencimiento' />
        </Grid>
      </SectionBox>
    </CardActions>
  )
}
